import './WholesalePartnerInfo.css';

function WholesalePartnerInfo() {
  return (
    <section className="wholesale-info" aria-label="Vape Supplier wholesale information">
      <div className="wholesale-info__intro">
        <div className="wholesale-info__intro-left">
          <span className="wholesale-info__arrow" aria-hidden="true" />
          <h2>Your Premier Vape Wholesale Partner</h2>
        </div>
        <p>
          Welcome to VAPE SUPPLIER TM, the leading distributor of premium vape products from the biggest brands
          in the industry.
        </p>
      </div>

      <hr className="wholesale-info__divider" />

      <div className="wholesale-info__grid">
        <div className="wholesale-info__col">
          <p>
            At the heart of our mission is a commitment to bespoke service, ensuring that each of our valued
            customers gains access to the largest range of Disposable Vapes, E-liquids, Shortfills and Hardware,
            including Vape Pod Kits, Vape Coils and all Vape accessories at competitive wholesale prices.
            Our dedication goes beyond mere distribution; we aim to be your trusted partner in success,
            providing personalised support tailored to meet the unique needs of your business.
          </p>
          <p>
            Understanding the dynamic nature of the vape market, VAPE SUPPLIER TM offers an unparalleled
            consultation service designed to keep your store at the forefront of the industry. Our team of
            experts is not just available for consultation calls but is also prepared to make store visits,
            bringing our expertise directly to your doorstep. This hands-on approach allows us to offer
            tailored advice, ensuring that your outlet is stocked with the best-selling products specifically
            curated for your local market.
          </p>
          <p>
            Moreover, we pride ourselves on our ability to offer bespoke pricing solutions, making premium
            products accessible while optimizing your sales and profit margins. With VAPE SUPPLIER TM, you're
            not just getting a supplier; you're gaining a partner committed to supporting and growing your
            business. Let us help you provide your customers with exactly what they want, ensuring your position
            as a top destination for vape enthusiasts.
          </p>
          <p>
            At VAPE SUPPLIER TM, we work closely and have developed partnerships with the largest manufacturers
            in the UK, China, and other parts of the world to ensure that we can provide the newest and latest
            products to our customers. This global network allows us to stay ahead of industry trends and bring
            you the most innovative vaping solutions as soon as they hit the market.
          </p>
          <p>
            We also offer the largest range of POS (Point of Sale) material across a huge range of brands,
            equipping our customers with the tools needed to successfully communicate to the end customer.
            From vibrant displays to informative brochures, our POS materials are designed to enhance your
            in-store experience and boost your sales.
          </p>
          <p>
            Join us at VAPE SUPPLIER TM, and experience the difference that a dedicated, expertly managed
            wholesale partnership can make for your Vape Store.
          </p>
          <h3>Enhanced Delivery Services at VAPE SUPPLIER TM</h3>
          <p>
            At VAPE SUPPLIER TM, we recognize the critical importance of timely restocks for your business.
            To support your needs and ensure that you never miss a sale due to stock shortages, we've designed
            a delivery service that stands out for its efficiency and reliability.
          </p>
        </div>

        <div className="wholesale-info__col">
          <h3>Exclusive Same-Day Delivery Service</h3>
          <p>
            We understand that in the fast-paced world of retail, every moment counts. That's why we offer an
            exclusive same-day delivery service for our valued wholesale customers. This premium service is
            tailored to meet the urgent needs of your business, ensuring that vaping products reach you not just
            promptly, but exactly when you need them. Please speak to your sales representative to discuss this
            service on a case by case basis.
          </p>
          <h3>Streamlined Order Dispatch</h3>
          <p>
            To keep your operations running smoothly and stock waiting times at an absolute minimum, all weekday
            orders placed by 4pm are dispatched the same day. This commitment to rapid processing means you can
            rely on VAPE SUPPLIER TM to replenish your inventory without delay, helping you maintain a seamless
            supply chain.
          </p>
          <h3>Saturday Delivery at No Extra Charge</h3>
          <p>
            Understanding the importance of weekend sales, we also offer a special provision for orders placed
            before 1pm on Fridays. These orders are shipped out for delivery on Saturday, ensuring you're fully
            stocked ahead of the weekend rush - all at no extra charge. This service underscores our commitment
            to your business's continuity and success, even during the busiest times.
          </p>
          <h3>Dedicated to Your Success</h3>
          <p>
            Our delivery options are more than just a service; they're a pledge to support the efficiency and
            growth of your business. With VAPE SUPPLIER TM, you gain a partner that truly understands the demands
            of the vape retail sector and is committed to ensuring your success through prompt and dependable
            product delivery.
          </p>
          <p>
            Choose VAPE SUPPLIER TM for your wholesale needs and experience the difference that our enhanced
            delivery services can make for your business.
          </p>
          <h3>Chat with us</h3>
          <p>
            For more information, or for any specific enquiry, get in touch with our team who are more than
            happy to answer any questions. Simply call on 0121 663 1339.
          </p>
        </div>
      </div>
    </section>
  );
}

export default WholesalePartnerInfo;
